export default "__VITE_ASSET__3388e4c6__"